import "../../components/seo_fields_manager/seo_snippet_preview.js";

class SEOPreview {
  constructor() {
    this.snippetPreview = new SEOSnippetPreview(
      { publicUrl: "" },
      {
        showSocialActions: false,
        editable: false,
      },
    );

    this.el = jQuery('<div id="seo_fields_manager" class="snippet-editor-container"></div>');
    this.el.append(this.snippetPreview.el);
  }

  // HELPERS
  update(data) {
    this.data = data;
    this.snippetPreview.data.publicUrl = this.data.publicUrl;
  }

  setActivePlatform(platform) {
    this.snippetPreview.setData(this.data[platform]);
  }
}

window.SEOPreview = SEOPreview;
